// GA4 e-commerce tracking
// pubsub.js / constants.js より後に defer ロードされる前提

(function () {
  var _cartCache = null;

  function mapItem(item, index) {
    return {
      item_name: item.product_title || item.title,
      item_id: item.sku || item.handle || String(item.variant_id),
      price: (item.final_price || item.price) / 100,
      item_variant: item.variant_title || '',
      quantity: item.quantity,
      index: index + 1
    };
  }

  function fetchCartAndCache() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _cartCache = cart;
        return cart;
      });
  }

  // ページロード時にカートをキャッシュ
  fetchCartAndCache();

  // add_to_cart
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source !== 'product-form' || !event.cartData) return;
    var item = event.cartData;
    if (!item.variant_id) return;
    fetchCartAndCache();
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: item.currency || 'JPY',
        items: [mapItem(item, 0)]
      }
    });
  });

  // remove_from_cart: 削除ボタンクリック時にDOMとキャッシュからデータ取得
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('cart-remove-button button[data-variant-id]');
    if (!removeBtn) return;

    var variantId = removeBtn.dataset.variantId;
    var row = removeBtn.closest('tr') ||
              removeBtn.closest('[id^="CartItem-"]') ||
              removeBtn.closest('[id^="CartDrawer-Item-"]');
    var itemName = '';
    var price = 0;
    var qty = 1;

    if (row) {
      var nameEl = row.querySelector('.cart-item__name');
      if (nameEl) itemName = nameEl.textContent.trim();
      var qtyInput = row.querySelector('.quantity__input');
      if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;
    }

    if (_cartCache && _cartCache.items) {
      var vid = parseInt(variantId, 10);
      var cartItem = _cartCache.items.find(function (i) { return i.variant_id === vid; });
      if (cartItem) {
        price = (cartItem.final_price || cartItem.price) / 100;
        if (!itemName) itemName = cartItem.product_title || cartItem.title;
        qty = cartItem.quantity;
      }
    }

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'JPY',
        items: [{
          item_name: itemName,
          item_id: variantId,
          price: price,
          quantity: qty
        }]
      }
    });

    setTimeout(fetchCartAndCache, 500);
  }, true);

  // view_cart: カートドロワーが開いたとき
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    var _drawerWasActive = false;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
        var isActive = cartDrawer.classList.contains('active');
        if (isActive && !_drawerWasActive) {
          _drawerWasActive = true;
          fetchCartAndCache().then(function (cart) {
            if (!cart.items || !cart.items.length) return;
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
              event: 'view_cart',
              ecommerce: {
                currency: cart.currency,
                value: cart.total_price / 100,
                items: cart.items.map(mapItem)
              }
            });
          });
        } else if (!isActive) {
          _drawerWasActive = false;
        }
      });
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // begin_checkout
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[name="checkout"], [href*="/checkout"]')) return;
    fetchCartAndCache().then(function (cart) {
      if (!cart.items || !cart.items.length) return;
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: cart.currency,
          value: cart.total_price / 100,
          items: cart.items.map(mapItem)
        }
      });
    });
  });
})();
